// PSTUDIO-3624: the expanded cell view exists to show as much of a cell's
// content as fits on screen without the user having to drag-resize the field.
// So the textarea auto-grows to its content: reset to `auto` to let it shrink,
// then set height to the full scrollHeight (+ borders, since box-sizing is
// border-box) so no content is clipped. Anything taller than the viewport is
// handled by the surrounding panel body's own vertical scroll.
//
// Kept as a standalone, dependency-free module so it can be unit-tested without
// pulling in the panel's Lit/design-system imports (which crash in node env).
export const autosizeTextarea = (el: HTMLTextAreaElement | null): void => {
  if (!el) return;
  el.style.height = 'auto';
  const borderY = el.offsetHeight - el.clientHeight;
  el.style.height = `${el.scrollHeight + borderY}px`;
};
